import { useSelector } from "app/hooks";

export const useReportDetails = () => {
  const { clientName, product, drawdownPercent } = useSelector(
    (state) => state.investmentDetails
  );
  const { investmentAmount } = useSelector((state) => state.investmentAmount);
  const { totalAllocation } = useSelector((state) => state.investmentFunds);
  const { amcRebate, fbrc } = useSelector((state) => state.charges);

  const continuteButtonDisabled =
    !clientName ||
    !product ||
    drawdownPercent === null ||
    totalAllocation !== 100 ||
    investmentAmount === 0 ||
    amcRebate === "" ||
    fbrc === "";

  return {
    continuteButtonDisabled,
  };
};
